// https://v4.mui.com/components/material-icons/#material-icons

import React from "react";
import { useRedirect } from "react-admin";
import { format, parse } from "date-fns";
import { Button } from "@material-ui/core";
import { red } from "@material-ui/core/colors";

import AcceptedIcon from "@material-ui/icons/CheckCircleOutline";
import AccountIcon from "@material-ui/icons/Business";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import AddAllIcon from "@material-ui/icons/ControlPointDuplicate";
import AdviceCompletedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import AdviceErrorIcon from "@material-ui/icons/AssignmentLateOutlined";
import AdviceProcessingIcon from "@material-ui/icons/AssignmentOutlined";
import AiIcon from "@material-ui/icons/AssistantOutlined";
import AisleOneSidedIcon from "@material-ui/icons/KeyboardBackspace";
import AisleTwoSidedIcon from "@material-ui/icons/SyncAlt";
import AnnouncementsIcon from "@material-ui/icons/VolumeUp";
import AppInfoIcon from "@material-ui/icons/Info";
import ApproveIcon from "@material-ui/icons/ThumbUp";
import ArrivedAtIcon from "@material-ui/icons/Alarm";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AttachPhotoIcon from "@material-ui/icons/AddAPhotoOutlined";
import AuditIcon from "@material-ui/icons/PlaylistAddCheck";
import AuditOutlinedIcon from "@material-ui/icons/PlaylistAddCheckOutlined";
import AutoIcon from "@material-ui/icons/FlashAuto";
import BarChartIcon from "@material-ui/icons/BarChart";
import BlankIcon from "@material-ui/icons/RadioButtonUnchecked";
import BrokeredAccountIcon from "@material-ui/icons/SwapHoriz";
import BugIcon from "@material-ui/icons/Android";
// The carrier's own company, as distinct from AccountIcon (a customer account,
// also a Business glyph) and TruckIcon (a load being moved).
import BusinessIcon from "@material-ui/icons/DomainOutlined";
import CalculateIcon from "@material-ui/icons/FunctionsOutlined";
import CalendarIcon from "@material-ui/icons/Event";
import CancelIcon from "@material-ui/icons/NotInterested";
import CheckIcon from "@material-ui/icons/Check";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CheckBoxBlankOutlinedIcon from "@material-ui/icons/CheckBoxOutlineBlankOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import CloseIcon from "@material-ui/icons/HighlightOff";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CollectedAtIcon from "@material-ui/icons/AccessTime";
import ContrastIcon from "@material-ui/icons/SettingsBrightness";
import CopyDownIcon from "@material-ui/icons/SystemUpdateAlt";
import CopyIcon from "@material-ui/icons/AddToPhotos";
import CreateIcon from "@material-ui/icons/Add";
import CreatedAtIcon from "@material-ui/icons/AddAlarm";
import CustomerIcon from "@material-ui/icons/PermContactCalendar";
import CustomersIcon from "@material-ui/icons/RecentActors";
import CustomFieldsIcon from "@material-ui/icons/ViewColumn";
import CustomCodeIcon from "@material-ui/icons/SettingsEthernet";
// Damage is the one exception managers must not miss, so it gets its own
// filled glyph and is always painted red — never the amber exception color.
import DamagedIcon from "@material-ui/icons/Report";
import DeleteIcon from "@material-ui/icons/Delete";
import DeleteSyncIcon from "@material-ui/icons/RestoreFromTrash";
import DeliveredAtIcon from "@material-ui/icons/AvTimer";
import DesktopIcon from "@material-ui/icons/DesktopWindows";
import DocumentIcon from "@material-ui/icons/Description";
import DocumentRepoIcon from "@material-ui/icons/FolderSpecial";
import DoubleCheckIcon from "@material-ui/icons/DoneAll";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import DropDownIcon from "@material-ui/icons/ArrowDropDown";
import EditIcon from "@material-ui/icons/Create";
import EditLocationIcon from "@material-ui/icons/EditLocation";
import EmailIcon from "@material-ui/icons/Email";
import ErrorFilledIcon from "@material-ui/icons/Error";
import ExceptionIcon from "@material-ui/icons/ReportProblemOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExportIcon from "@material-ui/icons/Publish";
import HelpIcon from "@material-ui/icons/Help";
import ImportIcon from "@material-ui/icons/GetApp";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import ImportExportFailedIcon from "@material-ui/icons/SwapVerticalCircle";
import InboundIcon from "@material-ui/icons/FastForward";
import InbounddOutlinedIcon from "@material-ui/icons/FastForwardOutlined";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import InternalAccountIcon from "@material-ui/icons/AlternateEmailOutlined";
import InventoryIcon from "@material-ui/icons/FormatListNumberedRtl";
import InventoryMapIcon from "@material-ui/icons/Room";
import InventoryMapOutlinedIcon from "@material-ui/icons/Room";
import OverdueIcon from "@material-ui/icons/HourglassFull";
import InvoicesIcon from "@material-ui/icons/MonetizationOn";
import InvoiceIcon from "@material-ui/icons/AttachMoney";
import KeyboardOutlinedIcon from "@material-ui/icons/KeyboardOutlined";
import LaunchIcon from "@material-ui/icons/Launch";
import LineChartIcon from "@material-ui/icons/ShowChart";
import LinkIcon from "@material-ui/icons/InsertLink";
import LinkOffIcon from "@material-ui/icons/LinkOff";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import LogsIcon from "@material-ui/icons/Android";
import LowInventoryAlertIcon from "@material-ui/icons/PlaylistAdd";
import ManualIcon from "@material-ui/icons/TouchApp";
import MobileIcon from "@material-ui/icons/PhoneAndroid";
import MoreIcon from "@material-ui/icons/More";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import OKIcon from "@material-ui/icons/CheckCircleOutline";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import OutboundIcon from "@material-ui/icons/FastRewind";
import OutbounddOutlinedIcon from "@material-ui/icons/FastRewindOutlined";
import PhotoIcon from "@material-ui/icons/PhotoLibrary";
import PieChartIcon from "@material-ui/icons/PieChart";
import PlacedAtIcon from "@material-ui/icons/AlarmOn";
import PrintIcon from "@material-ui/icons/Print";
import ProfileIcon from "@material-ui/icons/AccountBoxOutlined";
import ProductIcon from "@material-ui/icons/ShoppingCartOutlined";
import PublicIcon from "@material-ui/icons/PublicOutlined";
import RedoIcon from "@material-ui/icons/Redo";
import RefreshIcon from "@material-ui/icons/Refresh";
import RejectIcon from "@material-ui/icons/ThumbDown";
import ReleasedAtIcon from "@material-ui/icons/AlarmOff";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import RemovePhotoIcon from "@material-ui/icons/PhotoCameraOutlined";
import ReportsIcon from "@material-ui/icons/Assessment";
import ReturnIcon from "@material-ui/icons/FlipCameraAndroid";
import RoadmapIcon from "@material-ui/icons/MapOutlined";
import RollbackIcon from "@material-ui/icons/Restore";
import RunIcon from "@material-ui/icons/PlayArrow";
import SaveIcon from "@material-ui/icons/Save";
import ScannerIcon from "@material-ui/icons/CenterFocusWeak";
import SealIcon from "@material-ui/icons/LabelOutlined";
import SealOffIcon from "@material-ui/icons/LabelOffOutlined";
import SearchIcon from "@material-ui/icons/Search";
import ServiceIcon from "@material-ui/icons/LocalOffer";
import SetLocationIcon from "@material-ui/icons/PinDrop";
import ShowIcon from "@material-ui/icons/RemoveRedEye";
import SignatureIcon from "@material-ui/icons/Gesture";
import StaffIcon from "@material-ui/icons/SupervisorAccount";
import SubscriptionIcon from "@material-ui/icons/CardMembership";
import TableChartIcon from "@material-ui/icons/TableChart";
import TaskListIcon from "@material-ui/icons/AssignmentTurnedIn";
import TaskListOutlinedIcon from "@material-ui/icons/AssignmentTurnedInOutlined";
import TaskItemOutlinedIcon from "@material-ui/icons/CheckBoxOutlined";
import ThemeToggleIcon from "@material-ui/icons/Brightness6";
import TimelineIcon from "@material-ui/icons/Timeline";
import TimerIcon from "@material-ui/icons/Timer";
import TimerOffIcon from "@material-ui/icons/TimerOff";
import TourIcon from "@material-ui/icons/AccountTreeOutlined";
import TrackManagementIcon from "@material-ui/icons/WrapText";
import TrainIcon from "@material-ui/icons/Train";
import TransferIcon from "@material-ui/icons/Repeat";
import TruckIcon from "@material-ui/icons/LocalShippingOutlined";
import UploadIcon from "@material-ui/icons/CloudUpload";
import UserIcon from "@material-ui/icons/People";
import VideoCamIcon from "@material-ui/icons/VideocamOutlined";
import WarningIcon from "@material-ui/icons/Warning";
import XIcon from "@material-ui/icons/CloseOutlined";
import YardMapIcon from "@material-ui/icons/AccountTreeOutlined";
import YardSetupIcon from "@material-ui/icons/Settings";
// Font Icons:
import { HashIcon } from "./HashIcon";
import { ParkingIcon as SitIcon } from "./ParkingIcon";

export {
  AcceptedIcon,
  AccountIcon,
  AdviceCompletedIcon,
  AdviceErrorIcon,
  AdviceProcessingIcon,
  AddIcon,
  AddAllIcon,
  AiIcon,
  AisleOneSidedIcon,
  AisleTwoSidedIcon,
  AnnouncementsIcon,
  AppInfoIcon,
  ApproveIcon,
  ArrivedAtIcon,
  ArrowUpwardIcon,
  ArrowDownwardIcon,
  ArrowDropDownIcon,
  AttachFileIcon,
  AttachPhotoIcon,
  AuditIcon,
  AuditOutlinedIcon,
  AutoIcon,
  BarChartIcon,
  BlankIcon,
  BrokeredAccountIcon,
  BugIcon,
  BusinessIcon,
  CalculateIcon,
  CalendarIcon,
  CancelIcon,
  CheckIcon,
  CheckBoxBlankOutlinedIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClearIcon,
  CloseIcon,
  CloudUploadIcon,
  CollectedAtIcon,
  ContrastIcon,
  CopyDownIcon,
  CopyIcon,
  // CorporateAccountIcon,
  CreateIcon,
  CreatedAtIcon,
  CustomerIcon,
  CustomersIcon,
  CustomFieldsIcon,
  CustomCodeIcon,
  DamagedIcon,
  DeleteIcon,
  DeleteSyncIcon,
  DeliveredAtIcon,
  DesktopIcon,
  DocumentIcon,
  DocumentRepoIcon,
  DoubleCheckIcon,
  DownloadIcon,
  DropDownIcon,
  EditIcon,
  EditLocationIcon,
  EmailIcon,
  ErrorFilledIcon,
  ExceptionIcon,
  ExpandMoreIcon,
  ExportIcon,
  HashIcon,
  HelpIcon,
  ImportIcon,
  ImportExportIcon,
  ImportExportFailedIcon,
  InboundIcon,
  InbounddOutlinedIcon,
  InfoOutlinedIcon,
  InternalAccountIcon,
  InventoryIcon,
  InventoryMapIcon,
  InventoryMapOutlinedIcon,
  InvoiceIcon,
  InvoicesIcon,
  KeyboardOutlinedIcon,
  LaunchIcon,
  LineChartIcon,
  LinkIcon,
  LinkOffIcon,
  LogoutIcon,
  LogsIcon,
  LowInventoryAlertIcon,
  ManualIcon,
  MobileIcon,
  MoreIcon,
  NavigateBeforeIcon,
  OKIcon,
  OpenInNewIcon,
  OutboundIcon,
  OutbounddOutlinedIcon,
  OverdueIcon,
  PhotoIcon,
  PieChartIcon,
  PlacedAtIcon,
  PrintIcon,
  ProfileIcon,
  ProductIcon,
  PublicIcon,
  RedoIcon,
  RefreshIcon,
  RejectIcon,
  ReleasedAtIcon,
  RemoveIcon,
  RemovePhotoIcon,
  ReportsIcon,
  ReturnIcon,
  RoadmapIcon,
  RollbackIcon,
  RunIcon,
  SaveIcon,
  ScannerIcon,
  SealIcon,
  SealOffIcon,
  SearchIcon,
  ServiceIcon,
  SetLocationIcon,
  ShowIcon,
  SignatureIcon,
  SitIcon,
  StaffIcon,
  SubscriptionIcon,
  TableChartIcon,
  TaskListIcon,
  TaskListOutlinedIcon,
  TaskItemOutlinedIcon,
  TimelineIcon,
  ThemeToggleIcon,
  TimerIcon,
  TimerOffIcon,
  TourIcon,
  TrackManagementIcon,
  TrainIcon,
  TransferIcon,
  TruckIcon,
  UploadIcon,
  UserIcon,
  VideoCamIcon,
  WarningIcon,
  XIcon,
  YardMapIcon,
  YardSetupIcon,
};

// The one color damage is ever painted. Damaged stock has to read as damaged at
// a glance in every screen that shows it -- the grids, the inventory aside, the
// item forms, the pick dialog's "Show damaged" checkbox -- so the shade lives
// here next to DamagedIcon instead of being spelled out at each site, where one
// of them would eventually drift.
export const DAMAGED_COLOR = red[700];

export const CancelButton = ({ color, redirectTo, label }) => {
  const redirect = useRedirect();

  const handleClick = async (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    redirect(redirectTo);
  };

  return (
    <Button color={color} startIcon={<CloseIcon />} onClick={handleClick}>
      {label}
    </Button>
  );
};

export const MyDateField = ({ source, record = {} }) => {
  let value = record[source];
  if (value && value.match(/\d{4}-\d{2}-\d{2}/)) {
    value = format(parse(value, "yyyy-MM-dd", new Date()), "MM/dd/yyyy");
  }

  return <span>{value}</span>;
};
